module.exports = __webpack_public_path__ + "static/media/Assets-06-Books-of-type-03.4ce47fa1.png";